import React, { useState, useEffect } from 'react';
import './AdminFormaciones.css';
import AdminFormacionesGratis from '../FormacionesGratis/AdminFormacionesGratis';
import AdminCursosMoodle from '../CursosMoodle/AdminCursosMoodle';

/* ── Icons ── */
const IconClose = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconCheck = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconGift  = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><polyline points="20 12 20 22 4 22 4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><rect x="2" y="7" width="20" height="5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><line x1="12" y1="22" x2="12" y2="7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconBook  = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M4 19.5A2.5 2.5 0 016.5 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);





function CursosGratuitosMoodle() {
  const [cursos, setCursos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('https://centrocomunicar.com/api-comunicar/endpoints/cursos_admin.php?action=list')
      .then(r => r.json())
      .then(j => {
        if (j.success) setCursos((j.data || []).filter(c => c.seccion === 'gratuito'));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return null;
  if (cursos.length === 0) return (
    <div style={{background:'#edfaf4',border:'1.5px solid rgba(130,216,179,.3)',borderRadius:14,padding:'1rem 1.5rem',marginBottom:'1.5rem',fontSize:'.85rem',color:'#065f46'}}>
      🎁 No hay cursos Moodle marcados como <strong>Gratuito</strong> aún. Ve a <strong>Cursos Moodle</strong> y cambia la sección de algún curso a "Gratuito".
    </div>
  );
  return (
    <div style={{marginBottom:'2rem'}}>
      <h3 style={{fontSize:'1rem',fontWeight:700,color:'#111614',marginBottom:'1rem',display:'flex',alignItems:'center',gap:'.5rem'}}>
        🎁 Cursos Moodle gratuitos
        <span style={{background:'#edfaf4',color:'#4db88a',borderRadius:100,padding:'.2rem .7rem',fontSize:'.75rem',fontWeight:700}}>{cursos.length}</span>
      </h3>
      <div style={{display:'flex',flexDirection:'column',gap:'.7rem'}}>
        {cursos.map(c => (
          <div key={c.id} style={{background:'#fff',border:'1.5px solid rgba(130,216,179,.2)',borderRadius:12,padding:'.9rem 1.2rem',display:'flex',alignItems:'center',gap:'1rem',flexWrap:'wrap'}}>
            {c.imagen_url && <img src={c.imagen_url} alt="" style={{width:48,height:48,borderRadius:8,objectFit:'cover',flexShrink:0}}/>}
            <div style={{flex:1,minWidth:0}}>
              <strong style={{fontSize:'.9rem',color:'#111614',display:'block'}}>{c.fullname}</strong>
              <span style={{fontSize:'.75rem',color:'#5a6a63'}}>{c.shortname} · {c.total_inscritos} inscritos</span>
            </div>
            <span style={{background:'#d4f4e8',color:'#065f46',borderRadius:100,padding:'.25rem .75rem',fontSize:'.72rem',fontWeight:700}}>🎁 Gratuito</span>
          </div>
        ))}
      </div>
    </div>
  );
}





export default function AdminFormaciones() {
  const [tabActivo, setTabActivo] = useState('moodle');
  const [toast,     setToast]     = useState(null);

  const showToast = (msg, tipo='ok') => { setToast({msg,tipo}); setTimeout(()=>setToast(null),3000); };

  return (
    <div className="af-page">

      {toast && (
        <div className={`af-toast af-toast--${toast.tipo}`}>
          {toast.tipo==='ok'?<IconCheck/>:<IconClose/>} {toast.msg}
        </div>
      )}

      {/* HEADER */}
      <div className="af-header">
        <div className="af-header__left">
          <h1>Formaciones</h1>
          <p>Gestiona cursos de Moodle y formaciones gratuitas</p>
        </div>
      </div>

      {/* TABS */}
      <div className="af-tabs-nav">
        <button
          className={`af-tab-nav-btn ${tabActivo==='moodle'?'af-tab-nav-btn--active':''}`}
          onClick={()=>setTabActivo('moodle')}
        >
          <IconBook/> Cursos Moodle
        </button>
        <button
          className={`af-tab-nav-btn ${tabActivo==='gratis'?'af-tab-nav-btn--active':''}`}
          onClick={()=>setTabActivo('gratis')}
        >
          <IconGift/> Gratuitas
        </button>
      </div>

      {/* TAB MOODLE — componente real conectado a la API */}
      {tabActivo === 'moodle' && (
        <AdminCursosMoodle />
      )}

      {/* TAB GRATUITAS */}
      {tabActivo === 'gratis' && (
        <div className="af-tab-gratis">
          <CursosGratuitosMoodle />
          <AdminFormacionesGratis />
        </div>
      )}

    </div>
  );
}